import { useEffect, useState } from 'react';
import { getServiceRequestTags } from 'src/services/client';

export interface ServiceRequestTag {
  id: string;
  name: string;
  [key: string]: any;
}

interface UseServiceRequestTagsReturn {
  serviceRequestTags: ServiceRequestTag[];
  isLoading: boolean;
  error: string | null;
}

export const fetchServiceRequestTagsData = async (): Promise<
  ServiceRequestTag[]
> => {
  const response: any = await getServiceRequestTags();

  if (!response || (!response.ok && response.status !== 200)) {
    throw new Error('Failed to fetch service request tags');
  }

  const responseJson: ServiceRequestTag[] = await response.json();
  return responseJson ?? [];
};

export const useServiceRequestTags = (): UseServiceRequestTagsReturn => {
  const [serviceRequestTags, setServiceRequestTags] = useState<
    ServiceRequestTag[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadServiceRequestTags = async (): Promise<void> => {
      setIsLoading(true);
      setError(null);

      try {
        const result: ServiceRequestTag[] = await fetchServiceRequestTagsData();
        setServiceRequestTags(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setIsLoading(false);
      }
    };

    loadServiceRequestTags();
  }, []);

  return { serviceRequestTags, isLoading, error };
};

export default useServiceRequestTags;
